import styled from 'styled-components';

const QRCodeWrapper = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem;
  text-align: center;
`;

const QRImage = styled.img`
  max-width: 200px;
  margin: 1rem auto;
`;

const Title = styled.h2`
  color: var(--color-fg-default);
  margin-bottom: 1rem;
`;

const Description = styled.p`
  color: var(--color-fg-muted);
  margin-bottom: 1rem;
`;

export default function QRCode() {
  return (
    <QRCodeWrapper>
      <Title>扫码关注</Title>
      <Description>扫描下方二维码关注我们的公众号</Description>
      <QRImage src="wechat-qrcode.jpeg" alt="公众号二维码" />
    </QRCodeWrapper>
  );
}